const wishlistEl = document.querySelector('#wishlist-page')
const addToWishlistEl = document.querySelectorAll('.add-to-wishlist')
const removeFromWishlistEl = document.querySelectorAll('.remove-from-wishlist')
const clearWishlistEl = document.querySelector('#clear-wishlist')

const getWishlist = () => {
    const cookie = document.cookie.split('; ').find((cookie) => {
        const [key] = cookie.split('=')

        return key === 'wishlist'
    })

    let product_ids = []

    if (cookie !== undefined) {
        const [_, values] = cookie.split('=')

        product_ids = values.split(',')
    }

    return product_ids
}

const setWishlist = (values, days = 30) => {
    values = values.join(',')

    const date = new Date()

    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)

    document.cookie = `wishlist=${values}; expires=${date.toUTCString()}; path=/`
}

const deleteWishlist = () => {
    document.cookie = 'wishlist=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
}

const addToWishList = (e, product_id) => {
    const currentTarget = e.currentTarget
    let wishlist = getWishlist()

    wishlist.push(product_id)

    setWishlist(wishlist)

    currentTarget.style.display = 'none'
    currentTarget.nextElementSibling.style.display = 'flex'
}

const removeFromWishlist = (e, product_id, wishlist_page = false) => {
    const currentTarget = e.currentTarget
    let wishlist = getWishlist()

    wishlist = wishlist.filter((id) => id !== product_id)

    if (wishlist != '') {
        setWishlist(wishlist)
    } else {
        deleteWishlist()
    }

    currentTarget.style.display = 'none'

    if (!wishlist_page) {
        currentTarget.previousElementSibling.style.display = 'flex'
    } else {
        currentTarget.closest('.wishlist-product').remove()

        wishlist = getWishlist()

        if (wishlist.length === 0) {
            wishlistEl.querySelector('.wishlist-empty-products').style.display =
                'flex'
            clearWishlistEl.style.display = 'none'
        }
    }
}

if (typeof wishlistEl !== undefined && wishlistEl !== null) {
    const emptyProductsEl = wishlistEl.querySelector('.wishlist-empty-products')
    const productsEl = wishlistEl.querySelector('.wishlist-products')

    const getProducts = () => {
        const cookie = document.cookie.split('; ').find((cookie) => {
            const [key] = cookie.split('=')

            return key === 'wishlist'
        })

        let product_ids = []

        if (cookie !== undefined) {
            const [_, values] = cookie.split('=')

            product_ids = values.split(',')
        }

        wishlistEl.style.display = 'block'

        if (product_ids.length > 0) {
            let params = [
                {
                    type: 'product_ids',
                    label: product_ids,
                },
            ]

            let url_params = encodeURI(JSON.stringify(params))
            const url = `https://app.glossylounge.com/api/searchV2/?query=${url_params}`

            fetch(url)
                .then((response) => response.json())
                .then((products) => {
                    if (products.length > 0) {
                        clearWishlistEl.style.display = 'inline-block'
                        productsEl.style.display = 'grid'

                        products.forEach((product) => {
                            const variants = JSON.parse(product.variants)

                            const compareAtPrice = variants
                                .filter(
                                    (variant) =>
                                        variant.node.compareAtPrice !==
                                        undefined
                                )
                                .map((variant) =>
                                    parseFloat(variant.node.compareAtPrice)
                                )

                            if (compareAtPrice.length > 0) {
                                product.compareAtPrice = Math.max(
                                    ...compareAtPrice
                                )
                            } else {
                                product.compareAtPrice = 0
                            }

                            const productElement =
                                productsEl.querySelector('.wishlist-product')

                            const currentProductEl =
                                productElement.cloneNode(true)
                            const currentProductImageEl =
                                currentProductEl.querySelector(
                                    '.wishlist-product-image img'
                                )
                            const currentProductLinkEl =
                                currentProductEl.querySelectorAll('a')
                            const currentProductPriceEl =
                                currentProductEl.querySelectorAll(
                                    '.wishlist-product-price span'
                                )
                            const currentPrice = currentProductPriceEl[0]
                            const discountedPrice = currentProductPriceEl[1]

                            currentProductEl.style.display = 'flex'
                            currentProductImageEl.src = product.featured_image
                            currentProductLinkEl.forEach((link) => {
                                link.href = `/products/${product.handle}`
                            })
                            currentProductLinkEl[1].textContent = product.title
                            currentPrice.textContent = `AED ${product.maxprice}`
                            currentPrice.setAttribute(
                                'doubly-currency-aed',
                                product.maxprice * 100
                            )
                            currentPrice.setAttribute('doubly-currency', 'AED')

                            if (product.compareAtPrice > 0) {
                                discountedPrice.parentElement.style.display =
                                    'inline'
                                discountedPrice.textContent = `AED ${product.compareAtPrice}`
                                discountedPrice.setAttribute(
                                    'doubly-currency-aed',
                                    product.compareAtPrice * 100
                                )
                                discountedPrice.setAttribute(
                                    'doubly-currency',
                                    'AED'
                                )
                            }

                            currentProductEl.setAttribute(
                                'data-product-id',
                                product.product_id
                            )

                            productsEl.appendChild(currentProductEl)
                        })

                        productsEl
                            .querySelectorAll('.remove-from-wishlist')
                            .forEach((element) => {
                                element.addEventListener('click', (e) => {
                                    const product_id = element
                                        .closest('.wishlist-product')
                                        .getAttribute('data-product-id')

                                    removeFromWishlist(e, product_id, true)
                                })
                            })
                    }
                })
        } else {
            emptyProductsEl.style.display = 'flex'
        }
    }

    getProducts()

    clearWishlistEl.addEventListener('click', () => {
        let products = wishlistEl.querySelectorAll('.wishlist-product')
        products = [...products].slice(1)

        deleteWishlist()

        products.forEach((product) => {
            product.remove()
        })

        emptyProductsEl.style.display = 'flex'
        clearWishlistEl.style.display = 'none'
    })
}

const checkProductInWishlist = () => {
    const wishlist = getWishlist()
    const wishlistButtons = document.querySelector('div.wishlist-buttons')

    if (wishlistButtons) {
        const productId = wishlistButtons.getAttribute('data-product-id')
        const exists = wishlist.find(
            (currentVariantId) => currentVariantId === productId
        )

        if (exists !== undefined) {
            wishlistButtons.querySelector('.add-to-wishlist').style.display =
                'none'
            wishlistButtons.querySelector(
                '.remove-from-wishlist'
            ).style.display = 'flex'
        }
    }
}

checkProductInWishlist()

addToWishlistEl.forEach((element) => {
    element.addEventListener('click', (e) => {
        const product_id =
            e.currentTarget.parentElement.getAttribute('data-product-id')

        addToWishList(e, product_id)
    })
})

removeFromWishlistEl.forEach((element) => {
    element.addEventListener('click', (e) => {
        const product_id =
            e.currentTarget.parentElement.getAttribute('data-product-id')

        removeFromWishlist(e, product_id)
    })
})
